import {Component, Inject} from "@angular/core";
import {Resource} from "../../../models/resource";
import {ReservationData} from "../../../models/reservationData";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {locale as polish} from './../i18n/pl';
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";

@Component({
    selector: 'resource-calendar-modal-component',
    templateUrl: './resourceCalendarModal.component.html',
    styleUrls: ['./resourceCalendarModal.component.scss']
})
export class ResourceCalendarModalComponent {
    public resource: Resource;
    public reservations: ReservationData[];

    constructor(
        public dialogRef: MatDialogRef<ResourceCalendarModalComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService
    ) {
        this.resource = _data.resource;
        this.reservations = _data.reservations || [];
        this.translationLoader.loadTranslations(polish);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}